import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decimalPipe'
})
export class DecimalPipePipe implements PipeTransform {

  transform( value: number): unknown {
    if(typeof(value)==="number"){
      return (""+value).includes("-")? value : (value).toFixed(2);
    }
    else{
      return value;
    }
  }

}
